import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { isEmptyArray } from '../../../../../utils/array-utils';
import { createFetchedData } from '../../../../../utils/fetched-data/create-fetched-data';
import { getCacheDuration } from '../../../../../utils/get-cache-duration';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { getMemberPaymentCards } from '../../../selectors/member/payment-cards/get-member-payment-cards';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
export const removeMemberPaymentCard = async (cardId) => {
    if (!isMemberSignedIn())
        throw new Error('Cannot remove payment card when no user is signed in.');
    const memberPaymentCards = getMemberPaymentCards();
    if (!memberPaymentCards) {
        throw new Error('Cannot remove member payment card. Member payment cards have not been loaded.');
    }
    if (isEmptyArray(memberPaymentCards)) {
        throw new Error('Cannot remove member payment card. Member has no payment cards.');
    }
    if (!memberPaymentCards.find(card => card.id === cardId)) {
        throw new Error(`Cannot remove member payment card. Card with id: '${cardId}' does not exist.`);
    }
    await ocapiClient.instance.v1.loyalty.members.paymentCards.remove(cardId);
    runInAction(() => {
        temporaryLoyaltyDomainStore.data.memberPaymentCards = createFetchedData(memberPaymentCards.filter(card => card.id !== cardId), getCacheDuration('member'));
    });
};
